import { RootState } from 'editor/src/store/index';

const getSelectedGalleryImagesIds = (state: RootState) => state.gallery.selectedImagesIds;

export default getSelectedGalleryImagesIds;
